import { Loader, MultiSelect } from '@mantine/core';
import { IconMessage2 } from '@tabler/icons-react';
import { ReactNode } from 'react';

import { nonEmptyGroupsFilter, usePagesOptions } from './usePagesOptions';

import { Platforms } from '@/types';

type PagesMultiselectProps = {
  id?: string;
  value?: string[];
  onSelect: (value: string[]) => void;
  platform?: Platforms | 'all';
  isLoading?: boolean;
  isDisabled?: boolean;
  required?: boolean;
  error?: ReactNode | string;
};

export const PagesMultiselect = ({
  id,
  value,
  onSelect,
  isDisabled,
  required,
  error,
  platform,
}: PagesMultiselectProps) => {
  const { options, pagesCount, isFetching } = usePagesOptions({ platform });

  const nothingFound = !isFetching && pagesCount === 0 ? 'No pages available' : undefined;

  return (
    <MultiSelect
      id={id}
      clearable
      disabled={isDisabled}
      required={required}
      value={value}
      comboboxProps={{
        withinPortal: true,
        transitionProps: { transition: 'pop', duration: 200, timingFunction: 'ease' },
      }}
      data={options}
      filter={nonEmptyGroupsFilter}
      placeholder={isFetching ? 'Loading pages...' : 'Pick a page to add'}
      nothingFoundMessage={nothingFound}
      searchable
      hidePickedOptions
      rightSection={isFetching ? <Loader size="xs" /> : null}
      leftSection={<IconMessage2 size="1rem" />}
      onChange={(value) => onSelect(value)}
      error={error}
      rightSectionWidth={60}
      styles={{
        input: {
          maxHeight: 150,
          overflowY: 'auto',
        },
      }}
    />
  );
};
